import { request } from '@umijs/max';

// 获取补贴变动日志分页列表
export async function getUserButieLogPage({
  pageSize,
  current,
  filter,
  sorter,
}: {
  pageSize: number;
  current: number;
  filter: API.FormValues;
  sorter: string;
}) {
  return request('/api/admin/userButieLog/page', {
    method: 'POST',
    data: {
      pageSize,
      current,
      filter,
      sorter,
      with: ['shop', 'operator', 'user', 'order'],
    },
  });
}

// 获取补贴变动日志详情
export async function getUserButieLogInfo(values: API.FormValues) {
  return request('/api/admin/userButieLog/info', {
    method: 'POST',
    data: {
      ...values,
      with: ['shop', 'operator', 'user', 'order'],
    },
  });
}
